import type { SVGAttributes } from 'vue'
import type { FunctionalComponent } from 'vue'

export const ArrowDownIcon = (props: SVGAttributes) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M13.75 7.07812V8.95312L10 12.9281L6.25 8.95312V7.07812H13.75Z" fill="var(--colors-text-secondary)" />
    </svg>
  )
}

export const ArrowDownLineIcon = (props: SVGAttributes) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_131040_57677)">
        <path d="M12 6.5L7.5 11L3 6.5" stroke="var(--colors-text-base)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_131040_57677">
          <rect width="16" height="16" fill="var(--colors-bg-base)" transform="matrix(0 1 -1 0 16 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}

interface ArrowDownSolidIconProps {
  class?: string
}

export const ArrowDownSolidIcon: FunctionalComponent<ArrowDownSolidIconProps> = (props) => {
  return (
    <svg class={props.class} xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
      <path d="M6.78125 0.65625V1.15625L3.78125 4.33625L0.78125 1.15625V0.65625H6.78125Z" fill="var(--colors-bg-icon-quaternary)" />
    </svg>
  )
}
